module.exports = __webpack_public_path__ + "static/laptop-30731c2de3f91181383beebfcb319b86.svg";